import type { ComponentPropsWithoutRef } from 'react'

const BaseHeading = ({ className = '', ...props }: ComponentPropsWithoutRef<'h3'>) => (
  <h3 className={`flex h-6 items-center pl-3 ${className}`} {...props} />
)

export default BaseHeading
